import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  requests: PropTypes.arrayOf(PropTypes.object).isRequired,
}


// TODO: Consider implementing this as a selector that's shared with ProxyEditor
const stringifyHeaders = (h) => {
  return `${Object.keys(h).map(k => `${k.toLowerCase()}: ${h[k]}`).join('\n')}\n`
}

const buildRequestText = (req) => {
  if (req.headers === undefined) {
    console.error('unexpected empty headers when building request text.')
    return ''
  }
  const headers = stringifyHeaders(req.headers)
  return `${req.method} ${req.path} ${req.http_version}\n\n${headers}\n${req.body || ''}`
}

const buildResponseText = (req) => {
  const res = req.response
  const headers = stringifyHeaders(res.headers)
  return `${req.http_version} ${res.status_code}\n\n${headers}\n${res.body || ''}\n`
}

const ProxyHistory = ({ requests }) => (
  <ul data-uk-accordion>
    {requests.map((r, index) => {
      const requestLocation = r.path ? `http://sandbox-hackedu.com${r.path}` : 'Unknown Request'

      return (
        <li key={index} data-test-id="history-request-item">
          <div data-test-id="history-record-item" className="uk-accordion-title uk-text-small"><a href="#">{requestLocation}</a></div>
          <div className="uk-accordion-content">
            <ul data-uk-tab="active: 0">
              <li className="uk-active"><a>Request</a></li>
              {r.response &&
                <li data-test-id="history-response-tab" ><a href="#">Response</a></li>
              }
            </ul>
            <ul className="uk-switcher uk-margin">
              <li>
                <textarea
                  style={{
                    width: 874,
                    height: 350,
                    resize: 'none',
                    padding: 14,
                    background: '#333',
                    color: '#EEE',
                  }}
                  data-test-id="history-request-detail"
                  value={buildRequestText(r)}
                  spellCheck={false}  
                  readOnly
                />
              </li>
              {r.response &&
                <li>
                  <textarea
                    data-test-id="history-response-detail"
                    style={{
                      width: 874,
                      height: 350,
                      resize: 'none',
                      padding: 14,
                      background: '#333',
                      color: '#EEE',
                    }}
                    value={buildResponseText(r)}
                    spellCheck={false}
                    readOnly
                  />
                </li>
              }
            </ul>
          </div>
        </li>
      )
    })}
  </ul>
)

ProxyHistory.propTypes = propTypes


export default ProxyHistory
